<template>
  <div class="criteria-categories-screen">
    <page-header :customClass="'criteria-row'" :title="$t('app.criteria_categories.title')"/>
    <div class="row mt-20 mb-10 criteria-row">
      <div style="padding: 0;" class="col-sm-12 col-md-12">
        <div class="col-sm-1 checkbox-col">
          <base-checkbox
            :labelValue="$t('app.criteria_categories.attributes.name')"
            :id="'main'"
            @valueChanged="valueChanged('main',$event)"/>
        </div>
        <div class="col-sm-1 checkbox-col">
          <base-checkbox
            :labelValue="$t('app.sub_criteria_categories.attributes.name')"
            :id="'sub'"
            @valueChanged="valueChanged('sub',$event)"/>
        </div>
        <div class="col-sm-3">
          <base-checkbox
            :labelValue="$t('app.verification_questions.attributes.name')"
            :id="'question'"
            @valueChanged="valueChanged('question',$event)"/>
        </div>
       </div>
    </div>
    <div class="row mt-10 criteria-row">
      <div class="col-sm-6">
        <search-input
          :placeholder="searchPlaceHolder"
          @input="search"
        />
      </div>
      <div class="col-sm-6 text-right">
        <component
          v-bind:is="'base-button'"
          :title="this.$t('app.criteria_categories.create_criteria_category')"
          :classNames="`btn btn-orange rounded pull-right`"
          @clicked="clickCreateCriteriaCategories"
        ></component>
      </div>
    </div>
    <ul v-if="treeData.length > 0" class="cd-accordion-menu">
      <li>
        <label>
          <div class="row header-row" style="display: flex;">
            <!-- <div class="header-row"> -->
              <div class="col-md-2" style="display: flex;">
                <span>
                  {{$t('app.tables.baseState.identifier')}}
                </span>
              </div>
              <div class="col-md-6" style="display: flex;">
                <span>
                  {{$t('app.tables.baseState.name')}}
                </span>
              </div>
              <div class="col-md-4" style="display: flex; justify-content: flex-end;">
                <span>
                  {{$t('app.tables.global.actions')}}
                </span>
              </div>
            <!-- </div> -->
          </div>
        </label>
      </li>
      <category-item
        v-for="(data,index) in treeData"
        :selectedIndex="index"
        :isSearch="isSearch"
        :searchType="filterType"
        :key="index"
        :bus="bus"
        :model="data"/>
    </ul>
    <div class="empty-section" v-if="!isLoading && treeData.length === 0">{{$t('app.base_states.no_result')}}</div>
    <div class="empty-section" v-if="isLoading">{{$t('app.listLoading')}}</div>
  </div>
</template>

<script>
import Vue from 'vue';

import BaseCheckbox from '@/components/shared/inputs/BaseCheckbox';
import { mapActions, mapGetters } from 'vuex';
import Paginator from '@/components/shared/navigations/Paginator';
import BaseButton from '@/components/shared/buttons/BaseButton';
import GenericForm from '@/components/shared/forms/GenericForm';
import SearchInput from '@/components/shared/inputs/SearchInput';
import PageHeader from '@/components/shared/layouts/PageHeader';
import ConfigurableList from '@/components/shared/lists/ConfigurableList';
import CategoryItem from './CategoryItem';

export default {
  name: 'CriteriaCategoriesScreen',
  props: {},
  components: {
    'base-checkbox': BaseCheckbox,
    'configurable-list': ConfigurableList,
    'paginator-component': Paginator,
    'base-button': BaseButton,
    'search-input': SearchInput,
    'page-header': PageHeader,
    'category-item': CategoryItem,
  },
  data() {
    return {
      isLoading: false,
      filterType: 'main',
      options: [
        {
          name: 'Témakör',
          value: 'main',
        },
        {
          name: 'Altémakör',
          value: 'sub',
        },
        {
          name: 'Ellenőrző kérdés',
          value: 'question',
        },
      ],
      value: null,
      selectedCategoryId: undefined,
      selectedSubCategoryId: undefined,
      afterSearch: false,
      tableLoading: false,
      mainCategoryId: undefined,
      currentPageIndex: 1,
      searchTerm: '',
      criteriaCategory: undefined,
      verificationQuestion: undefined,
      subCategoryTitle: '',
      questionsTitle: '',
      newCriteriaCategory: {
        name: null,
        identifier: null,
        description: null
      },
      newVerificationQuestion: {
        identifier: null,
        name: null,
        legal_description: null,
        legal_reference: null
      },
      treeData: [],
      bus: new Vue(),
      mainIndex: undefined,
      subIndex: undefined,
      questionIndex: undefined,
      isSearch: false,
      filterTypes: [],
      currentLanguage: 'sr',
    };
  },
  created() {
    this.isLoading = true;
    this.bus.$on('updateQuestionForSub', (mainIndex, parentIndex, selectedIndex, question) => {
      this.treeData[mainIndex].children[parentIndex].children[selectedIndex].name = question.name;
      this.treeData[mainIndex].children[parentIndex].children[selectedIndex].legal_reference = question.legal_reference;
      this.treeData[mainIndex].children[parentIndex].children[selectedIndex].legal_description = question.legal_description;
    });
    this.bus.$on('updateQuestion', (parentIndex, selectedIndex, question) => {
      this.treeData[parentIndex].children[selectedIndex].name = question.name;
      this.treeData[parentIndex].children[selectedIndex].legal_reference = question.legal_reference;
      this.treeData[parentIndex].children[selectedIndex].legal_description = question.legal_description;
    });
    this.bus.$on('updateCategory', (parentIndex, selectedIndex, category) => {
      if (parentIndex !== undefined) {
        this.treeData[parentIndex].children[selectedIndex].name = category.name;
        this.treeData[parentIndex].children[selectedIndex].description = category.description;
      } else {
        this.treeData[selectedIndex].name = category.name;
        this.treeData[selectedIndex].description = category.description;
      }
    });
    this.bus.$on('deleteQuestionForSub', (mainIndex, parentIndex, selectedIndex) => {
      this.treeData[mainIndex].children[parentIndex].children.splice(selectedIndex, 1);
    });
    this.bus.$on('deleteQuestion', (parentIndex, selectedIndex) => {
      this.treeData[parentIndex].children.splice(selectedIndex, 1);
    });
    this.bus.$on('deleteCategory', (parentIndex, selectedIndex) => {
      if (parentIndex !== undefined) {
        this.treeData[parentIndex].children.splice(selectedIndex, 1);
      } else {
        this.treeData.splice(selectedIndex, 1);
      }
    });
    this.bus.$on('getChild', (id, index) => {
      this.fetchCriteriaCategoryTreeChild({ id }).then((response) => {
        this.treeData[index].children = [...response.questions, ...response.sub_categories];
        this.treeData[index].children.forEach((child) => {
          if (child.children && child.children.length > 0) {
            child.children.forEach((x) => {
              x.main_idx = index;
            });
          }
        });
      });
    });
    if (this.loggedInUser) {
      this.fetchCriteriaCategoryTree({}).then((response) => {
        this.isLoading = false;
        this.treeData = response;
      });
    }
    if (this.$route.params.id) {
      this.fetchCriteriaCategory(this.$route.params.id).then(() => {
        this.fetchVerificationQuestions({ criteriaCategoryId: this.$route.params.id });
      });
    }
  },
  computed: {
    userSpecs() {
      return this.loggedInUser.specializations.map(x => ({ value: x.id, text: this.$t(`app.specializations.${x.name}`) }));
    },
    searchPlaceHolder() {
      if (this.filterTypes.length === 1) {
        if (this.filterTypes.includes('main')) {
          return this.$t('app.criteria_categories_search.main');
        } else if (this.filterTypes.includes('sub')) {
          return this.$t('app.criteria_categories_search.sub');
        }
        return this.$t('app.criteria_categories_search.questions');
      } else if (this.filterTypes.length === 2) {
        if (this.filterTypes.includes('main') && this.filterTypes.includes('sub')) {
          return this.$t('app.criteria_categories_search.mainAndSub');
        } else if (this.filterTypes.includes('main') && this.filterTypes.includes('question')) {
          return this.$t('app.criteria_categories_search.mainAndQuestion');
        } else if (this.filterTypes.includes('sub') && this.filterTypes.includes('question')) {
          return this.$t('app.criteria_categories_search.subAndQuestion');
        }
      } else if (this.filterTypes.length === 3) {
        return this.$t('app.criteria_categories_search.all');
      }
      return this.$t('app.criteria_categories_search.all');
    },
    ...mapGetters({
      selectedCriteriaCategory: 'criteriaCategories/selectedCriteriaCategory',
      selectedSubCriteriaCategory:
        'criteriaCategories/selectedSubCriteriaCategory',
      allVerificationQuestions: 'verificationQuestions/allVerificationQuestions',
      commonData: 'partners/commonData',
      loggedInUser: 'loggedInUser',
    }),
    criteriaCategoryAttributes() {
      return [
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'description',
          type: 'text-area',
        },
      ];
    },
    verificationQuestionAttributes() {
      return [
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'legal_description',
          type: 'text-area',
        },
        {
          name: 'legal_reference',
          type: 'text',
        },
      ];
    },
    fields() {
      return [
        {
          title: 'Azonosító',
          key: 'identifier',
          isLink: true,
          cellClass: 'identifier-cell',
          route_path: 'criteria_categories',
        },
        {
          title: 'Név',
          cellClass: 'name-cell',
          isLink: true,
          key: 'name',
          route_path: 'criteria_categories',
        },
        {
          title: 'Leírás',
          cellClass: 'description-cell',
          key: 'description',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'edit-cell',
          key: 'addCategory',
          class: 'zmdi zmdi-collection-folder-image',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'edit-cell',
          key: 'addQuestion',
          class: 'zmdi zmdi-assignment-check',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'edit-cell',
          key: 'edit',
          class: 'zmdi zmdi-edit',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'delete-cell',
          key: 'delete',
          class: 'zmdi zmdi-delete',
        },
      ];
    },
    subFields() {
      return [
        {
          title: 'Azonosító',
          key: 'identifier',
          isLink: true,
          cellClass: 'sub-identifier-cell',
          route_path: 'criteria_categories',
        },
        {
          title: 'Név',
          cellClass: 'name-cell',
          isLink: true,
          key: 'name',
          route_path: 'criteria_categories',
        },
        {
          title: 'Leírás',
          key: 'description',
          cellClass: 'sub-description-cell',
        },
        {
          title: '',
          cellClass: 'edit-cell',
          key: 'empty',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'edit-cell',
          key: 'addQuestion',
          class: 'zmdi zmdi-assignment-check',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'edit-cell',
          key: 'edit',
          class: 'zmdi zmdi-edit',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'edit-cell',
          key: 'delete',
          class: 'zmdi zmdi-delete',
        },
      ];
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      CriteriaCategoryTreeSearch: 'criteriaCategories/CriteriaCategoryTreeSearch',
      fetchCriteriaCategoryTreeChild: 'criteriaCategories/fetchCriteriaCategoryTreeChild',
      fetchCriteriaCategoryTree: 'criteriaCategories/fetchCriteriaCategoryTree',
      fetchCriteriaCategories: 'criteriaCategories/fetchCriteriaCategories',
      fetchCriteriaCategory: 'criteriaCategories/fetchCriteriaCategory',
      fetchSubCriteriaCategory: 'criteriaCategories/fetchSubCriteriaCategory',
      createNewCriteriaCategory: 'criteriaCategories/createCriteriaCategory',
      fetchVerificationQuestions:
        'verificationQuestions/fetchVerificationQuestions',
      fetchVerificationQuestion:
        'verificationQuestions/fetchVerificationQuestion',
    }),
    valueChanged(type, value) {
      if (value === true) {
        this.filterTypes.push(type);
      } else {
        this.filterTypes = this.filterTypes.filter(item => item !== type);
      }
    },
    expandMain(id) {
      this.tableLoading = true;
      this.fetchCriteriaCategory(id).then(() => {
        this.fetchVerificationQuestions({ criteriaCategoryId: this.selectedCriteriaCategory.id }).then(() => {
          this.tableLoading = false;
          this.afterSearch = false;
        });
      });
    },
    expandSub(id) {
      this.selectedSubCategoryId = id;
      this.fetchVerificationQuestions({ criteriaCategoryId: id });
    },
    expandSubRow(id) {
      this.fetchCriteriaCategory(id).then(() => {
        this.fetchVerificationQuestions({ criteriaCategoryId: this.selectedCriteriaCategory.id });
      });
    },
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    clickCreateCriteriaCategories() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.criteria_categories.set_criteria_category'),
          fields: this.criteriaCategoryAttributes,
          model: this.newCriteriaCategory,
          submitTitle: this.$t('app.criteria_categories.buttons.save'),
          cancelTitle: this.$t('app.criteria_categories.buttons.cancel'),
          modelName: 'criteria_categories',
        },
        on: {
          submit: this.createCriteriaCategory,
          modalCanceled: this.resetNewCriteriaCategory,
        },
      });
    },
    createCriteriaCategory(newCriteriaCategory) {
      if (this.mainCategoryId) {
        newCriteriaCategory.parent_id = this.mainCategoryId;
      }
      this.createNewCriteriaCategory(newCriteriaCategory)
        .then((response) => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.criteria_categories.success.create'),
            notificationType: 'success',
          });
          this.fetchCriteriaCategoryTree({}).then((categories) => {
            this.isLoading = false;
            this.treeData = categories;
          });
          this.resetNewCriteriaCategory();
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    resetNewCriteriaCategory() {
      Object.assign(
        this.$data.newCriteriaCategory,
        this.$options.data().newCriteriaCategory,
      );
    },
    search(newTerm) {
      this.searchTerm = newTerm;
      if (this.searchTerm !== '') {
        this.isSearch = true;
        this.CriteriaCategoryTreeSearch({ term: this.searchTerm, filterTypes: this.filterTypes }).then((response) => {
          this.treeData = response;
          this.treeData.forEach((child, index) => {
            if (child.children && child.children.length > 0) {
              child.children.forEach((subChild, subIndex) => {
                if (subChild.children && subChild.children.length > 0) {
                  subChild.children.forEach((x) => {
                    x.main_idx = index;
                  });
                }
              });
            }
          });
        });
      } else {
        this.isSearch = false;
        this.fetchCriteriaCategoryTree({}).then((response) => {
          this.treeData = response;
        });
      }
    },
    questionSearch(newTerm) {
      this.searchTerm = newTerm;
      this.fetchVerificationQuestions({
        criteriaCategoryId: this.selectedCategoryId,
        searchTerm: this.searchTerm,
      });
    },
    navigateBack() {
      this.fetchVerificationQuestions;
      this.$router.push({ name: 'CriteriaCategoriesSreen' });
    },
    navigateToParent() {
      this.fetchVerificationQuestions;
      this.$router.push({
        name: 'CriteriaCategoriesSreen',
        params: { id: this.selectedCriteriaCategory.parent_id },
      });
    },
    selectCategory() {
      if (this.value) {
        this.fetchVerificationQuestions({ criteriaCategoryId: this.value.id }).then((response) => {
          this.selectedCategoryId = this.value.id;
        });
      } else {
        this.selectedCategoryId = undefined;
      }
    },
    selectFilterType() {
      this.filterType = this.value.value;
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.id) {
        this.fetchCriteriaCategory(to.params.id).then((response) => {
          this.fetchVerificationQuestions({ criteriaCategoryId: this.selectedCriteriaCategory.id });
        });
      }
    },
    currentPageIndex(newValue, oldValue) {
      this.fetchCriteriaCategories({
        pageIndex: newValue,
        searchTerm: this.searchTerm,
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.criteria-categories-screen {
  padding: 85px 40px;

  .header-row {
    color: #000000!important;
    font-weight: 500;
  }

  .id-header, .name-header {
    float: left !important;
    margin-right: 120px;
  }

  .extra-header {
    margin-right: 10px;
  }
  .criteria-row {
    // margin: 4.5em;
  }

  .checkbox-col {
    margin-right: 20px;
  }
  .empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }

  .file {
    border: none !important;
  }
  .center {
  display: flex;
  justify-content: center;
  align-items: center;
}

  ol, ul {
    list-style: none;
    padding: 0px;
  }

  a {
    color: #a0f6aa;
    text-decoration: none;
  }

  h1 {
    text-align: center;
    width: 90%;
    margin: 2em auto 0;
    color: #507b55;
    font-weight: bold;
  }

  .cd-accordion-menu {
    width: 100%;
    margin: 1em auto;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  }

  .cd-accordion-menu li {
    user-select: none;
    background: rgba(243, 243, 243, 0.918);
  }

  .cd-accordion-menu li span {
      float: right;
  }

  .cd-accordion-menu label, .cd-accordion-menu a {
    position: relative;
    display: block;
    padding: 18px 18px 18px 45px;
    box-shadow: inset 0 -1px #cecece;
    color: #696969;
  }
  .no-touch .cd-accordion-menu label:hover,
  .no-touch .cd-accordion-menu a:hover {
    background: #52565d;
  }
  .cd-accordion-menu label::before,
  .cd-accordion-menu label::after,
  .cd-accordion-menu a::after {
    /* icons */
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .cd-accordion-menu label {
    cursor: pointer;
  }

  .cd-accordion-menu label span {
    float: right;
    color: #828282;
  }

  .title {
    float: none !important;
    color: #696969 !important;
    font-weight: 500 !important;
    margin-right: 10%;
  }


  .cd-accordion-menu label i {
    float: right;
    color: #696969;
  }

  .cd-accordion-menu li.file > label::before {
  }
  .cd-accordion-menu li.folder > label::before {
    content: "\f054";
  }

  .cd-accordion-menu li.file > label::before {
  }
  .cd-accordion-menu li.add > label::before {
    content: "\f067";
  }


  .cd-accordion-menu label::before {
    /* arrow icon */
    font: normal normal normal 14px/1 FontAwesome;
    left: 18px;
    transform: translateY(-50%);
    transition: transform 0.3s;
  }
  .cd-accordion-menu label.open::before {
    transform: translateY(-25%) rotate(90deg);
  }

  .cd-accordion-menu ul label,
  .cd-accordion-menu ul a {
    background: #000;
    box-shadow: inset 0 -1px #cecece;
    padding-left: 82px;
  }

  .cd-accordion-menu ul label {
    background: #ffffff98  !important;
  }

  .no-touch .cd-accordion-menu ul label:hover,
  .no-touch .cd-accordion-menu ul a:hover {
    background: #3c3f45;
  }
  .cd-accordion-menu > li:last-of-type > label,
  .cd-accordion-menu > li > ul > li:last-of-type a {
    box-shadow: none;
  }
  .cd-accordion-menu ul label::before {
    left: 36px;
  }
  .cd-accordion-menu ul label::after,
  .cd-accordion-menu ul a::after {
    left: 59px;
  }
  .cd-accordion-menu ul ul label,
  .cd-accordion-menu ul ul a {
    padding-left: 100px;
  }
  .cd-accordion-menu ul ul label::before {
    left: 54px;
  }
  .cd-accordion-menu ul ul label::after,
  .cd-accordion-menu ul ul a::after {
    left: 77px;
  }
  .cd-accordion-menu ul ul ul label,
  .cd-accordion-menu ul ul ul a {
    padding-left: 118px;
  }
  .cd-accordion-menu ul ul ul label::before {
    left: 72px;
  }
  .cd-accordion-menu ul ul ul label::after,
  .cd-accordion-menu ul ul ul a::after {
    left: 95px;
  }
  .criteria-categories-list {
    margin-top: 10px;
  }

  .decreased-padding {
    padding: 5px;
  }

  .zero-padding {
    padding: 0px;
  }

  .rounded {
    border-radius: 4px;
  }

  .identifier-cell {
    width: 10%;
  }

  .sub-identifier-cell {
    width: 10%;
  }

  .question-identifier-cell {
    width: 10%;
  }

  .name-cell {
    width: 20%;
  }

  .description-cell {
    width: 30%;
  }

  .sub-description-cell {
    width: 20%;
  }

  .sub-categories-cell {
    width: 30%;
  }

  .verification-questions-cell {
    width: 20%;
  }

  .sub-verification-questions-cell {
    width: 35%;
  }

  .edit-cell {
    width: 5%;
  }

  .delete-cell {
    width: 5%;
  }

  .question-cell {
    width: 40%;
  }

  .legal-reference-cell {
    width: 40%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/modules/criteria_categories/CriteriaCategoriesScreen.vue